import { useEffect } from "react";

interface UseResumeApplicationPrefillArgs {
    isDTO: boolean;
    isMLTA: boolean;
    invitationCode: string | undefined;
    applicantType: "member" | "spouse" | undefined;
    loadSavedApplicationData: (invitationCode: string, applicantType: "member" | "spouse") => void;
}

/**
 * Prefills the form from previously saved backend data when a returning DTO or
 * MLTA applicant resumes their application (both products read via getApplication).
 */
export const useResumeApplicationPrefill = ({
    isDTO,
    isMLTA,
    invitationCode,
    applicantType,
    loadSavedApplicationData,
}: UseResumeApplicationPrefillArgs) => {
    useEffect(() => {
        if ((isDTO || isMLTA) && invitationCode && applicantType) {
            loadSavedApplicationData(invitationCode, applicantType);
        }
    }, [loadSavedApplicationData, invitationCode, applicantType, isDTO, isMLTA]);
};
